class Vertices {
  store;

  markerUniqueId;
  serial;
  locationId;
  srf;


  constructor(store, markerUniqueId, serial, locationId, srf) {
    this.store = store;
    this.markerUniqueId = markerUniqueId;
    this.serial = serial;

    this.locationId = locationId;
    this.srf = srf;
  }

  static fromJSON(store, json) {
    let { markerUniqueId, serial, locationId, srf} = json;
    return new Vertices(store, markerUniqueId, serial, locationId, srf);
  }
}

export default Vertices;
